import React, { useEffect } from 'react';
import T from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  resetFlexDraftState,
  setIsInFlexDraftFlow,
} from '@dmi/shared/redux/Payments/FlexDraft/actions';
import {
  selectPaymentDueDate,
  selectSetUpRowButtonsProps,
  selectSummaryScheduledDateString,
} from '@dmi/shared/redux/Payments/FlexDraft/selectors';
import {
  getMainClientInfo,
  getSelectedLoanAddress,
  getSelectedLoanMaskedLoanNumber,
} from '@dmi/shared/redux/Main/selectors';
import { resetState as resetSourcesState } from '@dmi/shared/redux/Payments/Sources/actions';

import { SetupOverviewScreen } from '../../../components/Payments/FlexDraft';

const SetupOverview = ({
  address,
  customerServicePhoneNumber,
  dispatchResetFlexDraftState,
  dispatchResetSourcesState,
  dispatchSetIsInFlexDraftFlow,
  maskedLoanNumber,
  navigation,
  paymentDueDate,
  paymentSummarySubText,
  setUpRowButtonsProps,
}) => {
  useEffect(() => {
    dispatchSetIsInFlexDraftFlow({ value: true });

    return () => {
      dispatchResetFlexDraftState();
      dispatchResetSourcesState();
      dispatchSetIsInFlexDraftFlow({ value: false });
    };
  }, [
    dispatchResetFlexDraftState,
    dispatchResetSourcesState,
    dispatchSetIsInFlexDraftFlow,
  ]);

  return (
    <SetupOverviewScreen
      address={address}
      customerServicePhoneNumber={customerServicePhoneNumber}
      maskedLoanNumber={maskedLoanNumber}
      navigation={navigation}
      paymentDueDate={paymentDueDate}
      paymentSummarySubText={paymentSummarySubText}
      setUpRowButtonsProps={setUpRowButtonsProps}
    />
  );
};

SetupOverview.propTypes = {
  address: T.string.isRequired,
  customerServicePhoneNumber: T.string.isRequired,
  dispatchResetFlexDraftState: T.func.isRequired,
  dispatchResetSourcesState: T.func.isRequired,
  dispatchSetIsInFlexDraftFlow: T.func.isRequired,
  maskedLoanNumber: T.string.isRequired,
  navigation: T.object.isRequired,
  paymentDueDate: T.string.isRequired,
  paymentSummarySubText: T.string.isRequired,
  setUpRowButtonsProps: T.object.isRequired,
};

const mapStateToProps = createStructuredSelector({
  /**
   * Store: Flex Draft
   */
  paymentDueDate: selectPaymentDueDate(),
  paymentSummarySubText: selectSummaryScheduledDateString(),
  setUpRowButtonsProps: selectSetUpRowButtonsProps(),
  /**
   * Store: Main
   */
  // eslint-disable-next-line sort-keys
  address: getSelectedLoanAddress(),
  customerServicePhoneNumber: getMainClientInfo('customerServicePhoneNumber'),
  maskedLoanNumber: getSelectedLoanMaskedLoanNumber(),
});

const mapDispatchToProps = (dispatch) => ({
  /**
   * Store: Flex Draft
   */
  dispatchResetFlexDraftState: () => dispatch(resetFlexDraftState()),
  dispatchSetIsInFlexDraftFlow: (payload) => dispatch(setIsInFlexDraftFlow(payload)),
  /**
   * Store: Payment Sources
   */
  // eslint-disable-next-line sort-keys
  dispatchResetSourcesState: () => dispatch(resetSourcesState()),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(SetupOverview);
